export default __webpack_public_path__ + "static/media/10.bc20af03.jpg";